export default [
    {
        key: "created_by",
        label: "Actualizado Por",
        visible: true,
    },
    {
        key: "is_viatic",
        label: "Viatico",
        visible: true,
    },
    {
        key: "created_at",
        label: "Actualizado",
        visible: true,
    },
]